module.exports = __webpack_public_path__ + "img/img_molecule.5164f32a.png";